import TooltipProps from '../../../types/props/TooltipProps';
import styles from './PlainTextToolTip.module.scss';

const PlainTextToolTip = ({ tooltipContent }: TooltipProps) => {
    return <div className={styles.plainTextToolTip}>{tooltipContent}</div>;
};

export default PlainTextToolTip;
